<template>
  <div>
    <GSLabel
      class="update-title"
      :text="getTitleText()"
      :size="46"
    ></GSLabel>
    <GSLabel
      class="update-description"
      :text="getDescriptionText()"
    ></GSLabel>
    <GSDropDownInput
      v-if="bindPhone"
      :dropdownPlaceholder="$t('lbl__select_country_region')"
      :dropdownItems="countryCodeList"
      :inputPlaceholder="$t('lbl__input_phone_number')"
      :inputDigitOnly="true"
      inputType="tel"
      @changed="updatePhoneNumber"
    ></GSDropDownInput>
    <GSInput
      v-if="bindEmail"
      :placeholder="$t('lbl__input_email')"
      @changed="updateEmailAddress"
    ></GSInput>
    <GSLabel
      :text="currentBindText"
      :size="28"
      color="#AEBBD2"
      :opacity="0.45"
      align="left"
    ></GSLabel>
    <GSRecaptcha
      class="recaptcha-widget"
      :onVerify="onVerifyRecaptcha"
      :language="recaptchaLanguage"
    ></GSRecaptcha>
    <GSButton
      :text="$t('btn__submit')"
      class="submit-button"
      @clicked="submit"
    ></GSButton>
    <GSAgreement
      :text="$t('lbl__user_agreement_{privacy_policy}')"
      :privacyPolicy="$t('lbl__privacy_policy')"
      @clicked="showPolicyPopup"
    ></GSAgreement>
  </div>
</template>

<script>
import GSLabel from '@/components/GSLabel.vue'
import GSDropDownInput from '@/components/GSDropDownInput'
import GSInput from '@/components/GSInput'
import GSButton from '@/components/GSButton'
import GSAgreement from '@/components/GSAgreement'
import GSRecaptcha from '@/components/GSRecaptcha'

import ApiUrlMixin from './mixins/ApiUrlMixin'
import BindBaseMixin from './mixins/BindBaseMixin'
import RequestMixin from './mixins/RequestMixin'
import { EVENT } from '@/constants/event'
import { COUNTRY_TO_RECAPTCHA_LANG, DEFAULT_LOCALE } from '@/constants'

export default {
  name: 'PhoneNewPage',
  mixins: [ApiUrlMixin, BindBaseMixin, RequestMixin],
  data () {
    return {
      currentBindValue: ''
    }
  },
  created () {
    this.request('get',
      this.getApiUrl('query'), {
        access_token: this.$store.getters['bind/requestParams'].access_token,
        ...this.getServerRoleClientParams()
      }, (data) => {
        this.currentBindValue = data[this.bindPhone ? 'phone' : 'email']
      })
  },
  methods: {
    getTitleText () {
      return this.bindPhone ? this.$t('title__change_phone_number') : this.$t('title__change_email')
    },
    getDescriptionText () {
      return this.bindPhone ? this.$t('lbl__change_phone_number_description') : this.$t('lbl__change_email_description')
    },
    submit () {
      if (this.bindPhone && this.$store.getters['bind/fullPhoneNumber'] === this.currentBindValue) {
        this.$emit(EVENT.SHOW_WARNING, this.$t('error__phone_already_bound'))
      } else if (this.bindEmail && this.$store.getters['bind/emailAddress'] === this.currentBindValue) {
        this.$emit(EVENT.SHOW_WARNING, this.$t('error__email_already_bound'))
      } else {
        this.bindPhone ? this.submitBindPhoneInit() : this.submitBindEmailInit()
      }
    },
    onVerifyRecaptcha(response) {
      this.captchaToken = response
    },
    showPolicyPopup () {
      this.$emit('show-policy')
    }
  },
  computed: {
    currentBindText () {
      return (this.bindPhone ? this.$t('lbl__current_bound_phone_number') : this.$t('lbl__current_bound_email')) + ` ${this.currentBindValue}`
    },
    recaptchaLanguage () {
      return COUNTRY_TO_RECAPTCHA_LANG[(this.$store.getters['bind/requestParams'].locale || DEFAULT_LOCALE).slice(-2)]
    }
  },
  components: {
    GSLabel,
    GSDropDownInput,
    GSInput,
    GSButton,
    GSAgreement,
    GSRecaptcha
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars/base';

.update-title {
  margin-top: $base-size * 50;
}

.update-description {
  margin-bottom: $base-size * 50;
}

.submit-button {
  margin-top: $base-size * 20;
}

.recaptcha-widget {
  width: max-content;
  margin: auto;
  margin-top: $base-size * 20;
}
</style>



// WEBPACK FOOTER //
// src/pages/bind/UpdatePage.vue